export default __webpack_public_path__ + "static/media/logo15.8e58bb98.svg";